import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import KpisInvoices from '../components/KpisInvoices'

const KpisInvoicePage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <KpisInvoices />
            </div>
          </main>
    )
}

export default KpisInvoicePage